import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import { Icon, IconProps } from '../../icon';

import styles from './icon.scss';

type DesktopNavbarIconProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> &
  IconProps & {
    wrapperClassname?: string;
    circle?: boolean;
  };

const COMPONENT_ID = 'modulor-desktop-navbar-icon';

export const DesktopNavbarIcon: ForwardRefExoticComponent<DesktopNavbarIconProps> = forwardRef<
  HTMLDivElement,
  DesktopNavbarIconProps
>(({ wrapperClassname, className, circle, ...iconProps }, ref) => {
  return (
    <div ref={ref} data-id={COMPONENT_ID} className={wrapperClassname}>
      <Icon
        size={32}
        style={{
          padding: circle ? 'var(--size-8, 8px)' : 'var(--size-6, 6px)',
        }}
        {...(iconProps as IconProps)}
        className={classNames(styles['desktop-navbar-icon'], className, {
          [styles['desktop-navbar-circle']]: circle,
        })}
      />
    </div>
  );
});

DesktopNavbarIcon.displayName = 'DesktopNavbarIcon';
